import React, { PureComponent } from 'react';
import styled from 'styled-components';

import FAQ from './FAQ';
import Embed from './Embed';

const Wrapper = styled.div`
  margin-bottom: 15px;
`;
class Infobox extends PureComponent {
  renderContent = () => {
    switch (this.props.infoboxContent) {
      case 'faq':
        return (
          <Wrapper>
            <FAQ setInfoboxContent={this.props.setInfoboxContent} />
          </Wrapper>
        );
      case 'embed':
        return (
          <Wrapper>
            <Embed setInfoboxContent={this.props.setInfoboxContent} />
          </Wrapper>
        );
      default:
        return null;
    }
  };

  render() {
    return this.renderContent();
  }
}

export default Infobox;
